const getPrettifiedQueryString = (query) =>
  query.toString().replace(/%2C/g, ',');

export default getPrettifiedQueryString;
